import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";

const GoogleSuccess = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const { setAuthToken } = useContext(AppContext);


    useEffect(() => {

        const params = new URLSearchParams(location.search);

        const token = params.get("token");
        const role = params.get("role");


        if(token){

            localStorage.setItem("authToken", token);

            setAuthToken(token);


            if(role === "customer"){

                localStorage.setItem(
                    "customerLoggedIn",
                    "true"
                );

                navigate("/customer-dashboard");

            }


            if(role === "worker"){

                localStorage.setItem(
                    "workerLoggedIn",
                    "true"
                );

                navigate("/worker-dashboard");

            }

        }

    }, []);


    return (
        <div>
            Logging in...
        </div>
    );
};


export default GoogleSuccess;